








import { Component, Vue, Prop } from 'vue-property-decorator';
import { Company } from '../../models/company/companyprofile';
import { vxm } from '@/store.vuex';

import {
  JOB_PAY_UOMS_MAPPING,
  JOB_DEFAULT_VALID_DAYS,
  JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING,
  JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING_DEFAULT,
} from '../MyJobs/MyJobsConstants';

@Component({
  name: 'JobPostingJsonLD',
})
export default class JobPostingJsonLD extends Vue {
  @Prop() CompanyInfo!: Company;
  @Prop() JobDetail!: any[];

  $moment: any;

  /**
   * Validate the job details and check if
   * it is not expired yet.
   */
  get isValidAndActiveJob() {
    if (!(this.JobDetail && this.JobDetail.length)) return false;

    const job = this.JobDetail[0];

    if (!job.endDTTM) return true;
    else return job.endDTTM > new Date().getTime();
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getSeoLogoUrl(companyCode);
  }

  renderDateStandardYMD(xDate: Date): string {
    return xDate ? this.$moment(xDate).format('YYYY-MM-DD') : '';
  }

  mapEmploymentType(job): string {
    let mappedValue = JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING.find(
      (x) =>
        x.jobPostingType === job.jobPostingType &&
        x.candidatePlacementTypeValue === job.candidatePlacementTypeValue,
    );

    // If type not found use the candidate placement text or default vaoue
    if (!(mappedValue || job.candidatePlacementTypeText)) {
      mappedValue = JOB_EMPLOYMENT_TYPES_JSONLD_MAPPING.find(
        (x) => x.default === true,
      );
    }

    return mappedValue
      ? mappedValue.jsonldCode
      : job.candidatePlacementTypeText;
  }

  jsonldContent() {
    if (!(this.JobDetail && this.JobDetail)) return {};

    const job = this.JobDetail[0];

    // Get the mapping for units
    const jobUOM = JOB_PAY_UOMS_MAPPING.find(
      (x) => x.code === job.jobPayUOM,
    ) || {
      text: '',
    };

    // Validate the job expiration (if empty set it to 30 days - TCMS-12055)
    const validThrough =
      job.endDTTM ||
      this.$moment(job.jobPublishDTTM).add(JOB_DEFAULT_VALID_DAYS, 'days');

    // Create JSON-LD content (validate everything  || '' to prevent null values)
    const jsonLD = {
      '@context': 'https://schema.org/',
      '@type': 'JobPosting',
      title: job.jobPostingName,
      description: `<p>${job.jobPostingDescription}</p>`,
      directApply: true,
      identifier: {
        '@type': 'PropertyValue',
        name: job.companyName,
        value: `${job.jobPostingId}`,
      },
      datePosted: this.renderDateStandardYMD(job.jobPublishDTTM),
      validThrough: this.renderDateStandardYMD(validThrough) || '',
      employmentType: this.mapEmploymentType(job),
      hiringOrganization: {
        '@type': 'Organization',
        name: job.companyName,
        sameAs: this.CompanyInfo.companyUrl || '',
        logo: this.getCompanyLogoUrl(this.CompanyInfo.companyCode),
      },
      applicantLocationRequirements: {
        '@type': 'Country',
        name: job.jobCountryCode || '',
      },
      //jobLocationType: `${job.remoteJobType === 'yes' ? 'TELECOMMUTE' : ''}`,
      jobLocationType: '',
      jobLocation: {},
      workHours: job.workHours || '',
      jobImmediateStart: job.startImmediately ? 'Yes' : 'No',
      jobStartDate: this.renderDateStandardYMD(job.startDTTM),
      // Map the skils array to a concatenated string
      skills: `${
        job.jobSkills && job.jobSkills.length ? job.jobSkills.join(', ') : ''
      }`,
      totalJobOpenings: job.remainingPositions || 0,
      baseSalary: {
        '@type': 'MonetaryAmount',
        currency: job.jobCurrencyCode || '',
        value: {
          '@type': 'QuantitativeValue',
          maxValue: job.jobPayRateHigh,
          minValue: job.jobPayRateLow,
          unitText: jobUOM.text || '',
        },
      },
    };

    // jobLocationType: Checks if the job is remote and set the values
    if (job.remoteJobType === 'yes') {
      jsonLD.jobLocationType = 'TELECOMMUTE';
    } else if (job.facility) {
      const facility = job.facility || {};
      // If the job is not remote the location is added
      jsonLD.jobLocation = {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          streetAddress: facility.name || '',
          addressLocality: facility.city || '',
          addressRegion: facility.state || '',
          postalCode: facility.zip || '',
          addressCountry: facility.country || '',
        },
      };
    }

    return jsonLD;
  }
}
